import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UIBtnIcon',
    props: {
        icon: {},
        as: { default: "button" },
        rounded: { type: Boolean },
        theme: { default: "dark" }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            const _component_UIIcon = _resolveComponent("UIIcon");
            const _directive_cursor = _resolveDirective("cursor");
            const _directive_sound = _resolveDirective("sound");
            return _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.as), {
                type: _ctx.$attrs.type || (_ctx.as === 'button' ? 'button' : undefined),
                class: _normalizeClass(["UIBtnIcon relative inline-flex justify-center items-center size-em text-40 before:absolute before:inset-0 before:rounded-inherit before:transition-all transition-colors focus:outline-none disabled:opacity-40", {
                        'before:bg-black text-white hoverable:hover:before:bg-white hoverable:hover:text-black focus-visible:before:bg-white focus-visible:text-black': _ctx.theme === 'dark',
                        'before:bg-white text-black hoverable:hover:before:bg-accent focus-visible:before:bg-accent': _ctx.theme === 'light',
                        'rounded-full hoverable:hover:before:scale-150 focus-visible:before:scale-150': _ctx.rounded
                    }])
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_UIIcon, {
                        class: "Icon relative text-16",
                        name: _ctx.icon
                    }, null, 8, ["name"])
                ]),
                _: 1
            }, 8, ["type", "class"])), [
                [
                    _directive_cursor,
                    void 0,
                    void 0,
                    { hover: true }
                ],
                [
                    _directive_sound,
                    void 0,
                    void 0,
                    {
                        hover: true,
                        click: true
                    }
                ]
            ]);
        };
    }
});
